(() => {
  const activeClass = 'bb-cart-bar-active';
  let ticking = false;

  const updateCartBar = () => {
    ticking = false;
    const cartSection = document.querySelector('.cart-section');
    const cartBar = cartSection?.querySelector('.thb-cart-form--cart-collaterals');
    const mobile = window.matchMedia('(max-width: 1067px)').matches;

    if (!cartSection || !cartBar || !mobile) {
      document.body.classList.remove(activeClass);
      return;
    }

    document.body.classList.add(activeClass);
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateCartBar);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  document.addEventListener('cart:refresh', requestUpdate);
  document.addEventListener('line-item:change:end', requestUpdate);
  document.addEventListener('shopify:section:load', requestUpdate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartBar, { once: true });
  } else {
    updateCartBar();
  }
})();
